<template>
    <section class="container-chain">
        <div ref="elDryBar" class="dry-bar"/>
        <div class="to-fill-bar" :style="{'width': width + '%'}"/>

        <div class="itens">
            <div v-if="title" class="title">{{ title }}</div>

            <div
                v-for="(item, index) in data"
                :key="item.id"
                :class="{
                    'editing': item.editing,
                    'completed': item.completed,
                }"
                class="itens-link">
                <div :class="{'set-button': item.seted}">
                    <div class="point">
                        <button
                            v-if="clickable && (item.completed || item.editing)"
                            class="return-page"
                            @click="linkButtonHandler(item.link, index)">
                            <em v-if="item.completed && check" class="fal fa-check icon" />
                            <span v-else>{{ item.id }}</span>
                        </button>

                        <div v-else>
                            <em v-if="item.completed && check" class="fal fa-check icon" />
                            <span v-else>{{ item.id }}</span>
                        </div>

                        <div class="point-name" :class="{ 'point-name-check': !item.seted }">
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
	import { utilMixin } from '@/mixins'

	export default {
		name: 'ui-chain-menu2',

		mixins: [utilMixin],

		props: {
			/**
			 * Itens a serem mostradas no chain-menu
			 */
			data: {
				type: Array,
				required: false,
				default() {
					return []
				},
			},
			/**
			 * Define o título apresentado acima do chain-menu
			 */
			title: {
				type: String,
				required: false,
				default: null
			},
			/**
			 * Define se o ícone de check será mostrado nos botões referentes aos items concluídos
			 */
			check: {
				type: Boolean,
				required: false,
				default: true
			},
			/**
			 * Define se os itens do chain-menu serão clicáveis ou não
			 */
			clickable: {
				type: Boolean,
				required: false,
				default: true
			}
		},

		data() {
			return {
				setIndex: null
			}
		},

		computed: {
			/**
			 * Define o tamanho da barra de progresso a ser mostrada dada a quantidade de items
			 * concluídos ou em edição
			 */
			width() {
				const widthSpacing = 100 / (this.data.length - 1)
				const filterCompleted = this.data.filter(item => item.completed || item.editing)

				return (filterCompleted.length - 1) * widthSpacing
			}
		},

		mounted () {
			this.$root.$on('altere-point-selected', payload => {
				if (payload && this.$mx_hasValue(payload.index)) {
					this.link(payload.name, payload.index + 1)
				}
			})
		},

		beforeDestroy () {
			this.$root.$off('altere-point-selected')
		},

		methods: {
			activeThis(id, bool) {
				if (!bool) return
				if (this.clickable)
					this.list.forEach((item) => {
						if (item.id == id) item.active = true
						else item.active = false
						return item
					})
			},
			/**
			 * Abre o link referente à determinado item do chain-menu e altera o estado
			 * do item de menu da etapa atual
			 * 
			 * @param link String Nome da rota referente ao link posterior ao selecionado
			 * @param index Number Index do link que se deseja acessar
			 * @param setedCompleted Boolean Define se o item de menu atual deve ser marcado ou não como concluído
			 * @param setedEditing Boolean Define se o item de menu atual deve ser marcado ou não como em edição
			 */
			link(link, index, setedCompleted = true, setedEditing = false) {
				// Busca o item de menu setado atualmente
				const setedIndex = this.data.findIndex(item => item.seted)
				if (setedIndex < 0 || setedIndex === index || !link) return

				const items = [...this.data]
				// Define o novo estado do item de menu setado atualmente
				items[setedIndex].completed = setedCompleted
				items[setedIndex].editing = setedEditing
				items[setedIndex].seted = false

				// Seleciona o novo item de menu
				items[index].seted = true
				items[index].editing = true
				this.$emit('input', items)

				this.$router.push({ name: link })
			},
			/**
			 * Event handler que trata o evento de quando um dos botões no menu é acessado
			 */
			linkButtonHandler(link, index) {
				// Busca o item de menu setado atualmente
				const setedIndex = this.data.findIndex(item => item.seted)
				if (setedIndex < 0 || setedIndex === index || !link) return

				const setedCompleted = this.data[setedIndex].completed ||
					(this.$mx_hasValue(this.data[setedIndex + 1]) &&
						(this.data[setedIndex + 1].completed || this.data[setedIndex + 1].editing))
				const setedEditing = !setedCompleted &&
					this.$mx_hasValue(this.data[setedIndex - 1]) &&
					(this.data[setedIndex - 1].completed || this.data[setedIndex - 1].editing)

				// Chama o link e define o estado do item de menu setado atualmente
				this.link(link, index, setedCompleted, setedEditing)
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>